<template>
    <sub-page :fullPage="true" class="assetDetail">
        <div v-if="data" class="asset-detail">
            <div v-if="data.status!=1&&data.status!=0">
                <h2 class="asset-reason asset-allow" v-if="data.status==2">
                <i class="nucfont inuc-correct"></i> 已完成审批
            </h2>
            <h2 class="asset-reason asset-deny" v-if="data.status==3">
                <i class="nucfont inuc-incorrect"></i> <span>审批未通过</span> <span class="reason-des" v-if="data.approvalRemark">【未通过原因：{{data.approvalRemark}}】</span>
            </h2>
            </div>
            
            <div class="survey-content">
                    <div class="survey-type">
                        <h3 class="asset-title">
                            <span>编号：{{data.number}}</span>
                            <span class="limit">
                                <i>创建人：{{data.creatorName}}</i>
                                <i>创建日期：{{data.createTime.substring(0, 10)}}</i>
                            </span>
                            
                        </h3>
                        <table border="1" width="100%" class="table">
                            <tr class="table-title">
                                <td>培训内容</td>
                                <td>{{data.title?data.title:'-'}}</td>
                            </tr>
                            <tr class="table-title">
                                <td>培训部门</td>
                                <td>{{data.orgName?data.orgName:'-'}}</td>
                            </tr>
                            <tr class="table-title">
                                <td>培训对象</td>
                                <td>{{data.trainner?data.trainner:'-'}}</td>
                            </tr>
                            <tr class="table-title">
                                <td>培训时间</td>
                                <td>{{data.startTime.substring(0, 10)}} {{data.startTime.substring(11, 16)}} — {{data.endTime.substring(0, 10)}} {{data.endTime.substring(11, 16)}}</td>
                            </tr>
                            <tr class="table-title">
                                <td>培训教室</td>
                                <td>{{data.roomName}}</td>
                            </tr>
                            <tr class="table-title">
                                <td>培训人数</td>
                                <td>{{data.trainingNum?data.trainingNum+'人':'-'}}</td>
                            </tr>
                            <tr class="table-title">
                                <td>培训讲师及内容简介</td>
                                <td>{{data.content?data.content:'-'}}</td>
                            </tr>
                            <tr class="table-title">
                                <td>服务项</td>
                                <td>{{equipmentItems.length?equipmentItems.toString():'-'}}</td>
                            </tr>
                            <tr class="table-title">
                                <td>经办人</td>
                                <td>{{data.approverName?data.approverName:'-'}}</td>
                            </tr>
                            <tr class="table-title">
                                <td>电话</td>
                                <td>{{data.phone?data.phone:'-'}}</td>
                            </tr>
                            <tr class="table-title">
                                <td>主持人或跟班领导</td>
                                <td>{{data.compere?data.compere:'-'}}</td>
                            </tr>
                            <tr class="table-title table-footer" v-if="initFiles.length">
                                <td colspan="2" rowspan="1">
                                    <div class="ledger-attachment">
                                <h3>附件 (<span style="color:#22B9FF"> {{initFiles.length}} </span>)：</h3>
                                <ledger-file :initFiles="initFiles" :readonly="true"></ledger-file>
                            </div>
                                </td>
                            </tr>
                        </table>
                    </div>
            </div>
        </div>
        <div class="approve-group" v-if="data&&data.status==1">
            <el-button class="approve-btn" type="primary" @click="approve(false)">审批通过</el-button>
            <el-button class="approve-btn" type="danger" @click="approve(true)">驳 回</el-button>
        </div>
        <el-dialog :title="isDeny?'确认驳回申请？':'确认审批通过？'"
                       :visible.sync="dialogDeny"
                       width="510px"
                       :close-on-click-modal="false"
                       :modal-append-to-body="false">
                <el-form :model="dialogForm" ref="dialogForm" v-if="isDeny"
                         style="margin-right: 40px;"
                         label-width="140px">
                    <el-form-item :label="'备注：'">
                        <el-input
                        type="textarea"
                        placeholder="审核未通过原因"
                        :rows="5"
                        v-model="dialogForm.content"
                        maxlength="30"
                        show-word-limit
                        >
                        </el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" style="text-align: center;margin-top: -10px;">
                    <el-button type="primary" @click="approveConfirm">确 认</el-button>
                </div>
            </el-dialog>
    </sub-page>
</template>

<script>
    import api from '@/api';
    import SubPage from '@/components/Subpage.vue'
    import ledgerFile from './Components/File'

    export default {
        props: ['assetId'],
        components: {
            SubPage, ledgerFile
        },
        data() {
            return {
                isDeny:false,
                dialogForm:{
                    content:''
                },
                dialogDeny:false,
                data: null,
                initFiles: [],
                equipmentItems:[],
            }
        },
        created() {
            this.initData()
        },
        mounted() {
           
        },
         destroyed(){
            this.$emit('onClose');
        },
        methods: {
            approve(deny){
                this.isDeny = deny;
                this.dialogDeny=true;
            },
            initData() {
                api.getReserveRoomRecordDetail(this.assetId).then(res => {
                    this.data = res.package;
                    this.data.equipmentItem.forEach((val)=>{
                        this.equipmentItems.push(val.name);
                    })
                    this.initFiles = this.data.files;
                })
            },
            approveConfirm(){
                api.reserveRoomApprove(this.assetId,{
                    status:this.isDeny?'Fail':'Success',
                    remark:this.dialogForm.content
                }).then(res => {
                    this.$router.back();
                    this.$notify({
                        title: this.data.title,
                        message: '该审批已完成!',
                        type: 'success'
                        });
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    .assetDetail{
        /deep/ .el-card__body{
            display: flex;
        }
        
    }
    .approve-group{
        flex:0.15;
        display: flex;
        flex-direction: column;
        padding-top: 140px; 
        .approve-btn{
            width: 100px;
            margin:20px auto;
        }
      
    }
    .survey-content {
        width: 95%;
        margin: auto;
        .survey-type {
            margin-bottom: 20px;
        }

        .asset-title {
            padding: 0 8px 0 44px;
            height: 80px;
            line-height: 40px;
            color: #4d4d4d;
            background: #f4f3f8;
            font-weight: 600;
            word-wrap: break-word;
            display:flex;
            justify-content: space-between;
            align-items: center;
            .limit {
                padding-right: 10px;
                font-style: normal;
                color: #999;
                font-weight: normal;
                display:flex;
                flex-direction: column;
            }
        }

        .table {
            border: solid 1px #ebebeb;

            td {
                text-align: center;
                padding: 0 20px;
                height: 30px;
                @media screen and (max-width: 1280px) {
                    min-width: 0!important;
                }
            }
        }

        .table-title {
            font-weight: bold;
            color: #4d4d4d;

            td {
                min-width: 300px;
            }
        }

        .table-footer {
            background: #f4f3f8;
            color: #4d4d4d;
            td {
                text-align: left;
            }
        }

        .essay-box {
            padding: 10px 30px;
            border: solid 1px #ebebeb;
        }
    }

    .asset-detail {
        flex:1;
        width: 960px;
        margin: 0 auto;

        .asset-reason {
            margin-bottom: 20px;
            margin-left: 50px;
            // text-align: center;
            font-size: 20px;
            &.asset-allow{
                color: rgb(54, 166, 110);
            }
            &.asset-deny{
                color: rgb(242, 11, 11);
                .reason-des{
                    font-size: 14px;
                }
            }
        }


        .ledger-attachment {
            display: flex;
            > h3 {
                width: 80px;
                text-align: center;
                margin-right: 5px;
                line-height: 40px;
                color: #4d4d4d;
                font-weight: 600;
            }
            > p {
                flex: 1;
            }

            .ledger-file {
                flex: 1;
            }
            /deep/.el-upload-list__item {
                width: 135px;
                height: 135px;
                margin-right: 10px;
                margin-bottom: 10px;
            }
        }
    }
</style>
